import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { toast } from "react-toastify";
import axios from "axios";
import Config from "services/config/config";

const ChangeLobStatus = ({
  showLobChangeStatus,
  onClosePopup = () => {},
  selectedLob,
  lobCurrentStatus,
}) => {
  const [isChangeLoading, setIsChangeLoading] = useState(false);

  const newStatus = lobCurrentStatus === 1 ? 0 : 1;

  const handleStatusChange = async () => {
    if (!selectedLob) return;

    setIsChangeLoading(true);

    try {
      const res = await axios.patch(Config.lob.editLob, {
        id: selectedLob,
        status: newStatus,
      });

      if (res?.data?.status_code === 200) {
        toast.success(res.data.message || "LOB status updated successfully!");

        onClosePopup();
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error(res?.data?.message || "Failed to update LOB status");
        onClosePopup();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong while updating status"
      );
    } finally {
      setIsChangeLoading(false);
    }
  };

  return (
    <ModalPop
      title="Change Status"
      show={showLobChangeStatus}
      handleModalHide={onClosePopup}
      keyboard
      backdrop
    >
      <div className="text-center">
        <h4>Are you sure you want to change the status?</h4>

        <div className="col-md-12 d-flex justify-content-center mt-4">
          <Button
            className="btn btn-success mx-2"
            onClick={handleStatusChange}
            disabled={isChangeLoading}
          >
            {isChangeLoading ? "Updating..." : "Yes"}
          </Button>

          <Button
            className="btn btn-danger mx-2"
            onClick={onClosePopup}
            disabled={isChangeLoading}
          >
            No
          </Button>
        </div>
      </div>
    </ModalPop>
  );
};

export default ChangeLobStatus;
